import { memo } from 'react'

import ScrollIntoView from '@/components/rundown/ScrollIntoView.jsx'

import { useAtomValue } from 'jotai'
import { cn } from 'tailwind-variants'

import { autoScrollAtom } from '@/store/rundown.store'

import { useRundownSnap } from '@/features/rundown/rundown-page.store'

/**
 * The "Current cue" line, rendered only for the active row.
 */
export const CueActiveMarker = memo(function CueActiveMarker({
  isFirstCue,
}: {
  isFirstCue: boolean
}) {
  const { id: rundownId } = useRundownSnap()

  const autoScroll = useAtomValue(autoScrollAtom)
  const isAutoScrollEnabled = autoScroll[rundownId] ?? false

  return (
    <>
      <ScrollIntoView
        following={isAutoScrollEnabled}
        marginTop="-110px"
      />
      <div className="relative">
        <span
          className={cn([
            'mt-4 w-full h-1 block bg-[#ef4444] outline-4 outline-black',
            isFirstCue ? 'mb-4' : '',
          ])}
        />
        <span className="absolute -top-1.5 ml-8 text-xs font-bold uppercase text-[#ef4444] bg-black px-2">
          Current cue
        </span>
      </div>
    </>
  )
})
